import { TableCols } from '../interfaces/static-data';

export const LEGAL_PROGRAMMES: TableCols[] = [
  {
    key: 'issuerId',
    displayValue: 'Issuer',
    type: 'select',
  },
  {
    key: 'name',
    displayValue: 'Name',
  },
  {
    key: 'description',
    displayValue: 'Description',
  },
  {
    key: 'programmeDate',
    displayValue: 'Programme Date',
    type: 'date',
  },
];
